<div class="w-full h-full relative" #treemap_container>

  <div #treemap></div>

  <div
    class="tooltip"
    style="display: none"
    #tooltip
  >
    <div class="flex justify-between px-4 py-4 items-center bg-basic-100-transparent-10">
      <span class="px-2 py-1 rounded text-medium text-white" style="direction: ltr" id="percentage"></span>
      <span id="symbol" class="text-heading5"></span>
    </div>
    <div class="flex flex-col items-center gap-4 py-5">
      <div class="flex flex-col gap-2">
        <span class="text-small text-basic-100-transparent-70 text-center" i18n>آخرین قیمت</span>
        <span class="text-center" id="price"></span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-basic-100-transparent-70 text-small text-center" i18n>حجم معاملات</span>
        <span class="text-center" id="volume"></span>
      </div>
    </div>
  </div>
</div>
